export default __webpack_public_path__ + "static/media/1.57bc5f87.jpg";